export const USER_AUTH_HANDLER_MACHINE_ID = 'userAuthHandlerMachine';

export const userAuthHandlerMachineStates = {
  getClientConfigDetailsState: 'getClientConfigDetailsState',
  initializeAuthMachineState: 'initializeAuthMachineState',
  getClientAuthCodeState: 'getClientAuthCodeState',
  userLoginSuccessState: 'userLoginSuccessState',
  notLoggedInUserState: 'notLoggedInUserState',
  getPaymentAuthCodeState: 'getPaymentAuthCodeState',
  getPaymentsClientAuthenticationDetailsState:
    'getPaymentsClientAuthenticationDetailsState',
  getFormAuthCode: 'getFormAuthCode',
  getFormClientAuthDetailsState: 'getFormClientAuthDetailsState',
  getUserProfileDetailsState: 'getUserProfileDetailsState',
  finalState: 'finalState'
};

export const userAuthHandlerMachineTags = {};

export const userAuthHandlerMachineActions = {
  assignLocalConfigClientIDToContext: 'assignLocalConfigClientIDToContext',
  assignQueryParamsToContext: 'assignQueryParamsToContext',
  setIsAuthButtonLoadingToTrue: 'setIsAuthButtonLoadingToTrue',
  assignClientConfigDetailsToContext: 'assignClientConfigDetailsToContext',
  assignAuthMachineRefToContext: 'assignAuthMachineRefToContext',
  onSuccessGettingClientAuthCode: 'onSuccessGettingClientAuthCode',
  updateIsOtpSentToUserFalse: 'updateIsOtpSentToUserFalse',
  assignValuesToContext: 'assignValuesToContext',
  redirectToCallBackUrl: 'redirectToCallBackUrl',
  redirectToFallBackUrl: 'redirectToFallBackUrl',
  resetOtp: 'resetOtp',
  redirectToHomePage: 'redirectToHomePage',
  assignErrorMessageToContext: 'assignErrorMessageToContext',
  setIsAuthButtonLoadingToFalse: 'setIsAuthButtonLoadingToFalse',
  setIsUserLoggedInToTrue: 'setIsUserLoggedInToTrue',
  assignChildContextToParentContext: 'assignChildContextToParentContext',
  updateIsOtpSentToUserTrue: 'updateIsOtpSentToUserTrue',
  clearErrorMessageFromContext: 'clearErrorMessageFromContext',
  updateIsNewUserInContextToTrue: 'updateIsNewUserInContextToTrue',
  updateIsNewUserInContextToFalse: 'updateIsNewUserInContextToFalse',
  doChildMachineSelfTransition: 'doChildMachineSelfTransition',
  assignChildMachineSelfTransitionToTrue:
    'assignChildMachineSelfTransitionToTrue',
  assignChildMachineSelfTransitionToFalse:
    'assignChildMachineSelfTransitionToFalse',
  assignSelfTransitionToTrue: 'assignSelfTransitionToTrue',
  assignSelfTransitionToFalse: 'assignSelfTransitionToFalse',
  onSuccessGettingPaymentsClientAuthenticationDetails:
    'onSuccessGettingPaymentsClientAuthenticationDetails',
  onSuccessGettingPaymentAuthCode: 'onSuccessGettingPaymentAuthCode',
  handleErrorOnFailureGetClientConfigDetails:
    'handleErrorOnFailureGetClientConfigDetails',
  setLoginAccessAndRefreshToken: 'setLoginAccessAndRefreshToken',
  onSuccessOtpVerification: 'onSuccessOtpVerification',
  onSuccessGettingFormsAuthCode: 'onSuccessGettingFormsAuthCode',
  onSuccessGettingFormsClientAuthDetails:
    'onSuccessGettingFormsClientAuthDetails',
  onSuccessGettingUserProfileDetails: 'onSuccessGettingUserProfileDetails'
};

export const userAuthHandlerMachineServices = {
  getClientAuthCode: 'getClientAuthCode',
  getClientConfigDetailsApi: 'getClientConfigDetailsApi',
  getPaymentAuthCode: 'getPaymentAuthCode',
  getPaymentClientAuthenticationDetails:
    'getPaymentClientAuthenticationDetails',
  getFormAuthCode: 'getFormAuthCode',
  getFormClientAuthenticationDetails: 'getFormClientAuthenticationDetails',
  getUserProfileDetails: 'getUserProfileDetails'
};

export const userAuthHandlerMachineEvents = {
  assignValuesToContext: 'ASSIGN_VALUES_TO_CONTEXT',
  onSuccessUserLogin: 'ON_SUCCESS_USER_LOGIN',
  onSuccessOtpVerification: 'ON_SUCCESS_OTP_VERIFICATION',
  doSelfTransition: 'DO_SELF_TRANSITION',
  onClickGetOtpButton: 'ON_CLICK_GET_OTP_BUTTON',
  onClickBackButton: 'ON_CLICK_BACK_BUTTON',
  onEntryGetOTP: 'ON_ENTRY_GET_OTP',
  onSuccessGetOTP: 'ON_SUCCESS_GET_OTP',
  onErrorGetOTP: 'ON_ERROR_GET_OTP',
  onSuccessGetSignUpOTP: 'ON_SUCCESS_GET_SIGN_UP_OTP',
  doChildMachineSelfTransition: 'DO_CHILD_MACHINE_SELF_TRANSITION',
  onClickResendOtp: 'RESEND_OTP_CLICKED',
  resetAuthMachine: 'RESET_AUTH_MACHINE'
};

export const userAuthHandlerMachineGuards = {
  isCallBackUrlPresent: 'isCallBackUrlPresent',
  isFallBackUrlPresent: 'isFallBackUrlPresent',
  shouldFetchFormAuthCode: 'shouldFetchFormAuthCode',
  shouldFetchPaymentAuthCode: 'shouldFetchPaymentAuthCode',
  shouldCallUserProfileDetails: 'shouldCallUserProfileDetails'
};
